export class ChooseReasonModel {
  constructor() {
    this.id = "";
    this.title = "";
    this.icon = "";
    this.isSelected = false;
  }
}
